<template>
    <!-- =特色项目 -->
    <div class="project">
        <div class="title-warp">
            <h3 class="title">项目概况</h3>
        </div>
        <div class="project-state">
            <ul class="member-list">
                <li class="member-item" v-for="(item,index) in memberList" :key="index">
                    <p class="member-desc"><span class="member-name">{{item.name}}</span>
                        {{item.desc}}
                    </p>
                </li>
            </ul>
        </div>
        <div class="title-warp">
            <h3 class="title">特色项目</h3>
            <ul class="project-list">
                <li class="project-item csp" @click="goDetail">
                    <p class="project-name">
                        <span class="orange"># 美育共同体 #</span>
                        <span> —— 获得教育部重点扶持</span>
                    </p>
                    <p class="project-desc">
                        陈 雅
                        海南省国兴中学教研室副主任，正高级教师，省英语学科带头人。发表或获奖论文10多篇，主编专著《英语语法微写作》《英语学习导航必修2》，参编教辅书2部。主持或参与海南省教育科学规划课题4项，结题优秀1项。担任海南省“双五百人才工程”师资培训项目授课教师，多次为全省中学英语教师做讲座。指导年轻教师3人在海南省高中英语课堂教学评比中荣获一等奖，1人在“第九届全国高中英语课堂教学观摩研讨会”展示课评选获一等奖。
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                memberList: [{
                        name: '陈 雅',
                        desc: '海南省国兴中学教研室副主任，正高级教师，省英语学科带头人。发表或获奖论文10多篇，主编专著《英语语法微写作》《英语学习导航必修2》，参编教辅书2部。主持或参与海南省教育科学规划课题4项，结题优秀1项。担任海南省“双五百人才工程”师资培训项目授课教师，多次为全省中学英语教师做讲座。指导年轻教师3人在海南省高中英语课堂教学评比中荣获一等奖，1人在“第九届全国高中英语课堂教学观摩研讨会”展示课评选获一等奖。'
                    },
                    {
                        name: '王 英',
                        desc: '海南省农垦中学教研室副主任，正高级教师，省中学英语学科带头人，省拔尖人才，人民教育出版社教材培训专家团成员。发表或获奖论文10余篇。主持或参与省级以上课题5项，结题优秀4项。应邀为人教版新教材培训、海南省“国培计划”乡村教师培训、海南省“双五百”项目等做专题讲座10余场次。荣获全国优秀教师、全国三八红旗手、全国优秀外语教师、全省三八红旗手等荣誉称号。'
                    },
                    {
                        name: '吴聪燕',
                        desc: '海南中学英语教研组副组长，高级教师，省英语学科带头人，海南师范大学教育硕士研究生校外行业导师。主持省规划课题“基于英语学习活动观的阅读活动设计行动研究”已结题。曾获省优质课评比一等奖（第一名），教学案例评比一等奖；两次获省基础教育创新研究与实践论文一等奖；指导教师参加省级优质课评比获一等奖2次。近年做省级专题讲座、公开课10余场。'
                    },
                    {
                        name: '杨  飞',
                        desc: '海口市琼山中学英语学科组副组长，高级教师，省骨干教师。论文《高中英语测试结果关联统计分析方法运用研究》发表于《基础教育外语教学研究》。参与省级规划课题2项，分别获得良好和优秀等级。指导青年教师获海口市高中英语课堂教学评比活动二等奖1人次。受外研社聘为《英语》（新课标）高中修订版教材培训专家，并在海南省高中英语教材培训活动中执教示范课。'
                    }
                ]
            }
        },
        methods: {
            goDetail() {
                this.$router.push(`/home/project/detail/${1}`)
            }
        }
    }
</script>

<style lang="less" scoped>
    .title-warp {
        // padding-bottom: 14px;

        .title {
            background-color: #2BADFE;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            font-size: 24px;
            line-height: 2.1;
            color: #fff;
            font-weight: bold;
            padding: 0 3.7% 0 6.2%;
            width: 21%;
            box-sizing: border-box;
            letter-spacing: 2px;
            position: relative;

        &::before {
            content: " ";
            width: 28px;
            height: 48px;
            background-image: url("../../assets/studio/Icon_Bookmark.png");
            background-repeat: no-repeat;
            position: absolute;
            top: 0;
            left: 14px;
        }
        }
    }

    .member-list {
        margin-bottom: 5%;

        .member-item {
            padding: 0 0 4% 3.7%;
            border-left: 1px solid #2BADFE;
            position: relative;

            &:first-child {
                padding-top: 4%;
            }

            &:nth-last-child(2) {
                padding-bottom: 5%;
            }

            &:last-child {
                border-left: 0;
                margin-top: -1%;
            }

            &::before {
                position: absolute;
                left: 0px;
                transform: translateX(-50%);
                // top: 50%;
                // transform: translateY(-50%);
                content: "";
                width: 14px;
                height: 14px;
                padding: 6px;
                border: 1px solid #2C79FF;
                background-color: #2C79FF;
                background-clip: content-box;
                border-radius: 50%;
            }
        }

        .member-desc {
            font-size: 18px;
            font-weight: 300;
            line-height: 2;
        }

        .member-name {
            font-weight: 400;
            position: relative;

        }
    }


    .project-list {
        padding-left: 3%;
        padding-top: 5%;

        .project-item {


            .project-name {
                margin-bottom: 2.5%;
                font-size: 22px;
                position: relative;

                .orange {
                    color: #F25B00;
                }

                &::before {
                    position: absolute;
                    left: -45px;
                    top: 50%;
                    transform: translateY(-50%);
                    content: "";
                    width: 14px;
                    height: 14px;
                    padding: 6px;
                    border: 1px solid #2C79FF;
                    background-color: #2C79FF;
                    background-clip: content-box;
                    border-radius: 50%;
                }
            }

            .project-desc {
                font-size: 18px;
                font-weight: 300;
                line-height: 2;
            }
        }
    }
</style>